import { relativeTime, formatShortDate } from './format';

const IST_DATE_FORMATTER = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Kolkata',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

function istDateKey(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = Object.fromEntries(
    IST_DATE_FORMATTER.formatToParts(date)
      .filter(part => part.type !== 'literal')
      .map(part => [part.type, part.value]),
  );
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function getDaysAgoIst(dateStr) {
  const itemKey = istDateKey(dateStr);
  const todayKey = istDateKey(new Date());
  if (!itemKey || !todayKey) return null;

  const [y1, m1, d1] = todayKey.split('-').map(Number);
  const [y2, m2, d2] = itemKey.split('-').map(Number);
  const todayUtc = Date.UTC(y1, m1 - 1, d1);
  const itemUtc = Date.UTC(y2, m2 - 1, d2);
  return Math.max(0, Math.round((todayUtc - itemUtc) / (24 * 60 * 60 * 1000)));
}

export function formatLastAlertMessage(record) {
  if (!record?.published_at) return null;

  const company = record.company || 'Unknown';
  const days = getDaysAgoIst(record.published_at);

  if (days === 0) return `Last alert was today for ${company}`;
  if (days === 1) return `Last alert was yesterday for ${company}`;
  if (days != null) return `Last alert was ${days} days ago for ${company}`;
  return `Last alert for ${company}`;
}

export function getLastAlertHint(records, { trackedCompanies } = {}) {
  const latest = [...(records || [])]
    .filter(r => r.published_at)
    .filter(r => !trackedCompanies?.size || trackedCompanies.has(r.company))
    .sort((a, b) => new Date(b.published_at) - new Date(a.published_at))[0];

  if (!latest) return null;

  return {
    record: latest,
    message: formatLastAlertMessage(latest),
    headline: latest.title || 'Untitled',
    relative: relativeTime(latest.published_at),
    dateLabel: formatShortDate(latest.published_at),
    company: latest.company,
  };
}